<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
    font-weight: 400;
    color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Account Reports</h5>
  </div>

  <div class="container">
  <div class="modal-body">

    <!-- ✅ SINGLE ROW ONLY -->
    <div class="row g-4">

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Monthly Conveyance Details')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="monthlyConveyanceDetailsClick()">
              Monthly Conveyance Details
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Monthly Conveyance')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="monthlyConveyanceClick()">
              Monthly Conveyance
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Employee Salary Report')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="employeeSalaryReportClick()">
              Employee Salary Report
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Client Conveyance Assignment')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="clientConveyanceAssignmentClick()">
              Client Conveyance Assignment
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Penalty Summary')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="penaltySummaryClick()">
              Penalty Summary
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Article Stipend')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="articleStipendClick()">
              Article Stipend
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Bank Payment Report')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="bankPaymentReportClick()">
              Bank Payment Report
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Salary Slip')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="salarySlipClick()">
              Salary Slip
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Annual Salary Report')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="annualSalaryReportClick()">
              Annual Salary Report
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Annual Stipend Report')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="annualStipendReportClick()">
              Annual Stipend Report
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Expense Reimbursement Report')">
        <div class="card shadow mb-4" style="align-items:center;">
          <div class="card-body">
            <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                 (click)="expenseReimbursementClick()">
              Expense Reimbursement Report
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- END SINGLE ROW -->

  </div>
</div>